import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

const state = {
  rows: [],
  row: null,
  condition: {}
}
const actions = {
  init: ({ commit, state }) => {

  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0503MaterialLicense cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0503MaterialLicense search')
    return client.postData({ data: { search: { api: 'M0503MaterialLicenseService.searchDataDetails', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0503MaterialLicense add')
    commit('EDIT',
      {
        id: null,
        files: {},
        relates: {},
        belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0503MaterialLicense edit')
    return client.postData({ data: { find: { api: 'M0503MaterialLicenseService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0503MaterialLicense delete')
    return client.postData({ data: { delete: { api: 'M0503MaterialLicenseService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0503MaterialLicense save')
    return client.postData({ data: { save: { api: 'M0503MaterialLicenseService.saveData', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0503MaterialLicense download')
    return client.download({ data: { download: { api: 'M0503MaterialLicenseService.downloadData', input: condition } } })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/M0503MaterialLicense/M0503MaterialLicenseStore.js